import { render } from "./NewRegionCounts.vue?vue&type=template&id=ba142c7c&scoped=true"
import script from "./NewRegionCounts.vue?vue&type=script&lang=js"
export * from "./NewRegionCounts.vue?vue&type=script&lang=js"

import "./NewRegionCounts.vue?vue&type=style&index=0&id=ba142c7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba142c7c"]])

export default __exports__